import apiConfig from "constants/apiConfig";
import { GSTValidationResponse, Wallet } from "types/wallet";
import axiosClient from "utils/axiosClient";

export const fetchWallet = async (agencyId: string): Promise<Wallet> => {
    const response = await axiosClient.get(apiConfig.FETCH_WALLET.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const validateGSTNumber = async (agencyId: string, gstNumber: string): Promise<GSTValidationResponse> => {
    const response = await axiosClient.post(apiConfig.VALIDATE_GST_NUMBER.url.replace('<agencyId>', agencyId), {
        gstin: gstNumber
    });
    return response.data;
}

export const addGSTNumberToWallet = async (agencyId: string, validation_id: string | number): Promise<boolean> => {
    const response = await axiosClient.post(apiConfig.ADD_GST_NUMBER_TO_WALLET.url.replace('<agencyId>', agencyId), {
        validation_id
    });
    return response.data?.success || false;

}

export const createVBAAccount = async (agencyId: string): Promise<boolean> => {
    const response = await axiosClient.post(apiConfig.CREATE_VBA_ACCOUNT.url.replace('<agencyId>', agencyId));
    return response.data?.success || false;
}